export const MAIN_API = import.meta.env.VITE_API_HOST_CAP;
export const SECURE_MAIN_API = import.meta.env.VITE_API_HOST_DAP;
